export default __webpack_public_path__ + "static/media/include_8_female@3x.3e94853a.jpg";